import 'jquery-zoom';
import { Fancybox } from 'fancybox';

export default class ImageGallery {
    constructor($gallery) {
        this.$mainImage = $gallery.find('[data-image-gallery-main]');
        this.$selectOption = $gallery.find('.slick-current[data-image-gallery-main]');
        this.$mainImageQuickView = $gallery.find('[data-image-gallery-main-quick-view]');
        this.$mainImageNested = $gallery.find('[data-main-image]');
        this.$selectableImages = $gallery.find('[data-image-gallery-item]');
        this.$swipThumbnails = $gallery.find('.productView-for');
        this.$swipImage = $gallery.find('.productView-nav');
        this.currentImage = {};
    }

    init() {
        this.bindEvents();
        this.setImageZoom();
        this.fancyboxZoom();
    }

    setMainImage(imgObj) {
        this.currentImage = { ...imgObj };
        this.setActiveThumb();
        if ($('.halo-productView-custom').length) {
            this.swapMainImage0();
        }
        this.swapMainImage();
    }

    setAlternateImage(imgObj) {
        if (!this.savedImage) {
            this.savedImage = {
                mainImageUrl: this.$mainImage.find('img').attr('src'),
                zoomImageUrl: this.$mainImage.attr('data-zoom-image'),
                mainImageSrcset: this.$mainImage.find('img').attr('srcset'),
                $selectedThumb: this.currentImage.$selectedThumb,
            };
        }
        this.setMainImage(imgObj);

        if ($('.halo-productView-custom').length) {
            if ($(window).width() > 1024) {
                this.$mainImage.trigger('zoom.destroy');
                this.$mainImage.zoom({ url: this.$mainImage.attr('data-zoom-image'), touch: false });
            }
        }
    }

    restoreImage() {
        if (this.savedImage) {
            this.setMainImage(this.savedImage);
            delete this.savedImage;
        }
    }

    selectNewImage(e) {
        e.preventDefault();
        const $target = $(e.currentTarget);
        const imgObj = {
            mainImageUrl: $target.attr('data-image-gallery-new-image-url'),
            zoomImageUrl: $target.attr('data-image-gallery-zoom-image-url'),
            mainImageSrcset: $target.attr('data-image-gallery-new-image-srcset'),
            $selectedThumb: $target,
            mainImageAlt: $target.children().first().attr('alt'),
        };
        this.setMainImage(imgObj);
    }

    selectNewImage2(e) {
        const $target = $(e.currentTarget).find('.slick-current[data-image-gallery-item]');
        const imgObj = {
            mainImageUrl: $target.attr('data-image-gallery-new-image-url'),
            zoomImageUrl: $target.attr('data-image-gallery-zoom-image-url'),
            mainImageSrcset: $target.attr('data-image-gallery-new-image-srcset'),
            $selectedThumb: $(e.currentTarget).find('.slick-current'),
        };
        
        this.setMainImage(imgObj);

        if ($('.halo-productView-custom').length) {
            if ($(window).width() > 1024) {
                this.$mainImage.trigger('zoom.destroy');
                this.$mainImage.zoom({ url: $target.data('image-gallery-zoom-image-url')});
            }
        }
    }

    selectNewImage3(e) {
        const $target = this.$swipThumbnails.find('.slick-current[data-image-gallery-item]');
        const imgObj = {
            mainImageUrl: $target.attr('data-image-gallery-new-image-url'),
            zoomImageUrl: $target.attr('data-image-gallery-zoom-image-url'),
            mainImageSrcset: $target.attr('data-image-gallery-new-image-srcset'),
            $selectedThumb: $('.productView-for').find('.slick-current'),
            mainImageAlt: $target.children().first().attr('alt'),
        };

        this.setMainImage(imgObj);
    }

    setActiveThumb() {
        this.$selectableImages.removeClass('is-active');
        if (this.currentImage.$selectedThumb) {
            this.currentImage.$selectedThumb.addClass('is-active');
        }
    }

    swapMainImage() {
        const isBrowserIE = navigator.userAgent.includes('Trident');

        this.$mainImage.attr({ 'data-zoom-image': this.currentImage.mainImageUrl, })
            .find('a').attr({href: this.currentImage.mainImageUrl})
            .find('img').attr({src: this.currentImage.mainImageUrl})

        this.$mainImage.attr({
            'data-zoom-image': this.currentImage.zoomImageUrl,
        });
        
        if ($('.halo-productView-custom').length) {
            if ($(window).width() > 550) {
                this.$mainImage.find('.productView-img-container img').attr({srcset: this.currentImage.mainImageUrl});

                this.$mainImage.find('img.zoomImg').attr({src: this.currentImage.zoomImageUrl})
                    .find('img.zoomImg').attr({srcset: this.currentImage.zoomImageUrl});
            }
        }
        
        this.$mainImageNested.attr({
            alt: this.currentImage.mainImageAlt,
            title: this.currentImage.mainImageAlt,
        });

        if (isBrowserIE) {
            const fallbackStylesIE = {
                'background-image': `url(${this.currentImage.mainImageUrl})`,
                'background-position': 'center',
                'background-repeat': 'no-repeat',
                'background-origin': 'content-box',
                'background-size': 'contain',
            };

            this.$mainImageNested.css(fallbackStylesIE);
        }
    }

    swapMainImage0() {
        if ($(window).width() > 550) {
            this.$selectOption.attr({ 'data-zoom-image': this.currentImage.zoomImageUrl, })
                .attr({href: this.currentImage.mainImageUrl})
                .find('a').attr({href: this.currentImage.zoomImageUrl})
                .find('.productView-img-container img').attr({src: this.currentImage.mainImageUrl});
            this.$selectOption.find('.productView-img-container img').attr({srcset: this.currentImage.mainImageUrl});  
            this.$selectOption.find('img.zoomImg').attr({src: this.currentImage.zoomImageUrl})
                           .find('img.zoomImg').attr({srcset: this.currentImage.zoomImageUrl});

            this.setImageZoom();
        }
    }

    setImageZoom() {
        if ($(window).width() > 1024) {
           this.$mainImageQuickView.zoom({ url: this.$mainImageQuickView.attr('data-zoom-image'), touch: false });
        }
    }

    fancyboxZoom() {
        if($('.productView-nav').length > 0){
            var $imageProductRow = $('.productView-nav').find('.productView-image');
                fancyBoxImage($imageProductRow.find('[data-fancybox]'));
        }
        function fancyBoxImage($image){
            Fancybox.bind('[data-fancybox="images"]', {
                infinite: true,
                Thumbs: false
            });
        }
    }

    bindEvents() {
        this.$selectableImages.on('click', this.selectNewImage.bind(this));
        this.$swipThumbnails.on('afterChange', this.selectNewImage2.bind(this));
        this.$swipImage.on('afterChange', this.selectNewImage3.bind(this));
    }
}
